





































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { Toast } from "vant";
import { TbTbHandover } from "@/http";
import calculate from "@/common/util/calculate";
import { fmoney } from "@/common/util/money";
@Component({
  components: {},
})
export default class goodsDetails extends Vue {
  public $refs: {};

  show = false;

  form: any = {
    items: [],
  };

  fmoney = fmoney;

  loading = false;

  created() {}
  mounted() {}

  async init() {
    this.loading = true;
    try {
      let res = await TbTbHandover.GetHandoverGoods({
        accountId: JSON.parse(localStorage.getItem("padUserinfo")).id,
      });
      this.form = res;
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
  getpriceall() {
    let pri_al = this.form.items
      .map((v) => v.price)
      .reduce((pre, cur) => {
        return Number(pre) + Number(cur);
      }, 0);
    if (Number(pri_al < 0)) {
      return "-" + fmoney(Math.abs(pri_al).toString(), 2, true);
    } else {
      return fmoney(Math.abs(pri_al).toString(), 2, true);
    }
  }

  async showFun(id) {
    await this.init();
    this.show = true;
  }

  closeFun() {
    this.resetFun();
    this.show = false;
  }

  resetFun() {
    this.form = {
      items: [],
    };
  }
  //计算数
  getNum(){
      let num = 0;
      let arr = this.form.items.map((v) => v.price<0?'-'+v.salesNum:v.salesNum);
      if (arr.length > 0) {
          num = arr.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
      }
      return Number(num);
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/changeShifts/components/goodsDetails.vue